import { Form, message, Modal, Spin, Table, Tooltip } from 'antd';
//import * as XLSX from 'xlsx';

import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api/common';
import {
  AuditLog,
  AuditResponse,
  FeeFilterPayload,
  FeesDashboardListData,
  FeesDashboardPagedList,
  getAuditLog,
  getFeesPaymentList,
  retry,
  RetryResponse,
} from 'api/dashboard';
import { LoadingScreen } from 'common/components';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DownloadLogs from './DowloadLogs/DownloadLogs';
// import { dummyData } from './data/data';

type Props = {
  filter: FeeFilterPayload;
  onSubmit: (values: FeeFilterPayload) => Promise<void>;
  handleReset?: any;
  setOnlyDigitError: (error: boolean) => void;
};
function FeeFilterList({ filter, handleReset, setOnlyDigitError }: Props) {
  let payPagedList: FeesDashboardPagedList = {
    data: {
      noOfRecords: 0,
      currentPageIndex: 1,
      data: [],
    },
  };

  let retryResponse: RetryResponse = {
    data: '',
    message: '',
    responseCode: '',
    status: '',
  };

  let audit: AuditResponse = {
    data: [], // Initialize with an empty array for AuditLogs
  };

  const [_form] = Form.useForm<FeeFilterPayload>();
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditLog, setAuditLog] = useState(audit);
  const [_isRetry, setRetry] = useState(false);
  const [_retryRes, setRetryRes] = useState(retryResponse);
  const [selectedRecord, setSelectedRecord] = useState<FeesDashboardListData | null>(null);
  const [isDownloading, setIsDownloading] = useState(false);

  //filter.Username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');
  if (isAdmin != 'true') {
    filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
  }

  // console.log('_isRetry', _isRetry);
  // console.log('Filter', filter);

  useEffect(() => {
    setIsLoading(false);
    // console.log('Filter fees dashboard data', filter);
    filter.userId = sessionStorage.getItem('userId')?.toString();
    filter.pageNo = 1;
    filter.pageSize = 10;
    getFeesPaymentList(filter)
      .then((res) => {
        // console.log('Response fofrm the api in first time ', res);

        setPagedList(res);
        setOnlyDigitError(false);
      })
      .finally(() => {
        setIsLoading(true);
      });
  }, [filter, _isRetry]);

  const handleRetry = (record: FeesDashboardListData) => {
    setIsLoading(true);
    retry(record.PAYMENTREQUESTID)
      .then((res) => {
        setRetryRes(res);

        if (res.responseCode == '200') {
          message.success('Done Successfully!');
          setIsLoading(false);
          handleReset();

        } else {
          message.error(res.message);
        }
      })
      .finally(() => {
        setRetry(!_isRetry);
      });
  };

  const columns: ColumnsType<FeesDashboardListData> = [
    {
      key: 'PAYMENTREQUESTID',
      title: 'Request ID',
      dataIndex: 'PAYMENTREQUESTID',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
      className: '',
    },
    {
      key: 'LANUMBER',
      title: 'Loan Number',
      dataIndex: 'LANUMBER',
      fixed: 'left',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'LOANTYPE',
      title: 'Loan Type',
      dataIndex: 'LOANTYPE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'ACCOUNT_ID',
      title: 'Account Id',
      dataIndex: 'ACCOUNT_ID',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'SOURCEAPPLICATIONNAME',
      title: 'Source Application Name',
      dataIndex: 'SOURCEAPPLICATIONNAME',
      width: 250,
    },
    {
      key: 'REQUESTPURPOSE',
      title: 'Request Purpose',
      dataIndex: 'REQUESTPURPOSE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'MODE',
      title: 'Mode',
      dataIndex: 'MODE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    // {
    //   key: 'IMPACTMODE',
    //   title: 'Impact Mode',
    //   dataIndex: 'IMPACTMODE',
    //   ellipsis: true,
    //   render: (record) => (
    //     <Tooltip placement="topLeft" title={record}>
    //       {record}
    //     </Tooltip>
    //   ),
    // },
    {
      key: 'GATEWAYNAME',
      title: 'Gateway Name',
      dataIndex: 'GATEWAYNAME',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PAYMENTPURPOSE',
      title: 'Payment Purpose',
      dataIndex: 'PAYMENTPURPOSE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'MERCHANTID',
      title: 'Merchant ID',
      dataIndex: 'MERCHANTID',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'AMOUNT',
      title: 'Total Amount',
      dataIndex: 'AMOUNT',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'RequestStatus',
      title: 'Request Status',
      dataIndex: 'RequestStatus',
      ellipsis: true,
      render: (_) => (
        <>
          <Tooltip placement="topLeft" title={_}>
            {_}
          </Tooltip>
          {/* {record.RequestStatus == 'RECEIPT_FAILED' ? setRetry(true) : setRetry(false)} */}
        </>
      ),
    },
    {
      key: 'NEW_STATUS',
      title: 'New Status',
      dataIndex: 'NEW_STATUS',
      ellipsis: true,
      render: (_) => (
        <>
          <Tooltip placement="topLeft" title={_}>
            {_}
          </Tooltip>
          {/* {record.NEW_STATUS == 'Initiated' ? setRetry(true) : setRetry(false)} */}
        </>
      ),
    },
    {
      key: 'PAYMENTREF',
      title: 'PaymentRef',
      dataIndex: 'PAYMENTREF',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'REFTRANSACTION',
      title: 'Ref Transaction',
      dataIndex: 'REFTRANSACTION',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'RAZORPAY_ORDER_ID',
      title: 'Order Id',
      dataIndex: 'RAZORPAY_ORDER_ID',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'RAZORPAY_PAYMENT_ID',
      title: 'Payment Id',
      dataIndex: 'RAZORPAY_PAYMENT_ID',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'FUNDINGACCOUNT',
      title: 'Funding Account',
      dataIndex: 'FUNDINGACCOUNT',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'BANKCODE',
      title: 'Bank Code',
      dataIndex: 'BANKCODE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'CURRENCY',
      title: 'Currency',
      dataIndex: 'CURRENCY',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'FAVOURNAME',
      title: 'Favour Name',
      dataIndex: 'FAVOURNAME',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },

    {
      key: 'PAYMENTREQUESTDATETIME',
      title: 'Request Date & Time',
      dataIndex: 'PAYMENTREQUESTDATETIME',
      ellipsis: true,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'PENNANTRECEIPTDATE',
      title: 'Receipt Date & Time',
      dataIndex: 'PENNANTRECEIPTDATE',
      ellipsis: true,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'PENNANTRECEIPTNO',
      title: 'Pennant Receipt No',
      dataIndex: 'PENNANTRECEIPTNO',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'AUTH_CODE',
      title: 'AuthCode',
      dataIndex: 'AUTH_CODE',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'BYAGENT',
      title: 'By Agent',
      dataIndex: 'BYAGENT',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'REMARKS',
      title: 'Remark',
      dataIndex: 'REMARKS',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PAYMENTREQUESTERROR',
      title: 'Payment Request Status',
      dataIndex: 'PAYMENTREQUESTERROR',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'PENNANTERRORDESC',
      title: 'Receipt Status',
      dataIndex: 'PENNANTERRORDESC',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'WEBHOOKERROR',
      title: 'Webhook Status',
      dataIndex: 'WEBHOOKERROR',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'VERIFICATIONREASON',
      title: 'Verification Reason',
      dataIndex: 'VERIFICATIONREASON',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'AGENTREJECTREMARKS',
      title: 'Agent Reject Remarks',
      dataIndex: 'AGENTREJECTREMARKS',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'FeeType',
      title: 'Fee Type',
      dataIndex: 'FeeType',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },

    {
      key: 'FeeCode',
      title: 'Fee Code',
      dataIndex: 'FeeCode',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'FeeDescription',
      title: 'Fee Description',
      dataIndex: 'FeeDescription',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'FeeAmount',
      title: 'Fee Amount',
      dataIndex: 'FeeAmount',
      ellipsis: true,
      render: (record) => (
        <Tooltip placement="topLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      key: 'Action',
      title: 'Action',
      dataIndex: 'Action',
      //   fixed: 'right',
      render: (_text, record) => (
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <>
            <button
              className="btn btn-primary btn-sm prime-button"
              onClick={() => showModal(record)}
            >
              View Audit
            </button>

            <button
              className="btn btn-primary btn-sm prime-button"
              onClick={() => downloadAudit(record)}
            >
              Download
            </button>
            {record.RequestStatus == 'RECEIPT_FAILED' ? (
              // <button
              //   // className="ant-btn ant-btn-primary"
              //   // size="middle"
              //   className="btn btn-primary btn-sm prime-button"
              //   onClick={() => handleRetry(record)}
              // >
              //   Retry
              // </button>

              <button
                className="btn btn-primary btn-sm prime-button"
                onClick={() => handleRetry(record)}
              >
                Retry
              </button>
            ) : null}
          </>
        </span>
      ),
    },
  ];

  const auditCols: ColumnsType<AuditLog> = [
    {
      key: 'LANumber',
      title: 'Loan Number',
      dataIndex: 'LANumber',
      width: 80,
    },
    {
      key: 'Event',
      title: 'Event',
      dataIndex: 'Event',
      width: 300,
    },
    {
      key: 'EventDateTime',
      title: 'Event Date & Time',
      dataIndex: 'EventDateTime',
      width: 100,
      render: (date: string) => getFullDate(date),
    },
    {
      key: 'ErrorDescription',
      title: 'Error Description',
      dataIndex: 'ErrorDescription',
      width: 100,
    },
  ];
  let payfilter: FeeFilterPayload = {};
  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const showModal = (record: FeesDashboardListData) => {
    // setIsLoading(false);
    setIsModalLoading(true);
    getAuditLog(record.PAYMENTREQUESTID, false).then((res) => {
      setAuditLog(res);
      setIsModalOpen(true);
      // setIsLoading(true);
      setIsModalLoading(false);
    });
  };

  function getFullDate(date: string) {
    if (date != null) {
      let dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
      return dateMoment;
    }
  }
  const handleDownloadComplete = () => {
    setIsDownloading(false);
  };
  const downloadAudit = (record: FeesDashboardListData) => {
    setSelectedRecord(record);
    setIsDownloading(true);
  };

  // const downloadAudit = (record: FeesDashboardListData) => {
  //   getAuditLog(record.PAYMENTREQUESTID, false).then((res) => {
  //     console.log(res);
  //     const { data } = res;
  //     const fileName = 'RequestResponse_' + record.PAYMENTREQUESTID + '.xlsx';

  //     // Convert JSON to worksheet
  //     const worksheet = XLSX.utils.json_to_sheet(data);

  //     // Create a new workbook and append the worksheet
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

  //     // Write workbook to binary array buffer
  //     const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

  //     // Convert binary array buffer to Blob for downloading
  //     const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

  //     // Save the Blob to file
  //     //saveAs(blob, fileName);
  //   });
  //};

  // Utility function to convert string to ArrayBuffer
  // const s2ab = (s: any) => {
  //   const buf = new ArrayBuffer(s.length);
  //   const view = new Uint8Array(buf);
  //   for (let i = 0; i < s.length; i++) {
  //     view[i] = s.charCodeAt(i) & 0xff;
  //   }
  //   return buf;
  // };
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    setIsLoading(false);
    // debugger;
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    payfilter = filter;
    // console.log('Pay Filter ', payPagedList);

    //filter.Username = sessionStorage.getItem('user')?.toString();
    // if (isAdmin != 'true') {
    //   payfilter.sourceApplicationName = filter.sourceApplicationName;
    // }

    payfilter.pageNo = _pagination.current;
    payfilter.pageSize = _pagination.pageSize;

    getFeesPaymentList(payfilter).then((res) => {
      // console.log('response from the second api fetching the fees payment list', res);

      setPagedList(res);
      // console.log(res)
      setIsLoading(true);
    });
    // console.log(filter)
  };

  const maxWidthPerCell = 1000;

  const dataTable = calculateColumnsWidth(columns, pagedList.data.data, maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <Spin spinning={isModalLoading}>
        <Table
          columns={dataTable.columns}
          dataSource={dataTable.source}
          rowKey={rowKey}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          pagination={{
            pageSize: 10,
            total: pagedList.data.noOfRecords,
            current: pagedList.data.currentPageIndex == 0 ? 1 : pagedList.data.currentPageIndex,
          }}
          onChange={handleChange}
        />
      </Spin>
      ;
      <Modal
        title="Audit Log"
        style={{ padding: 20 }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="auto"
        footer={[<div></div>]}
      >
        <div className="">
          {isModalLoading ? (
            <LoadingScreen />
          ) : (
            <Table<AuditLog>
              dataSource={auditLog?.data}
              columns={auditCols}
              scroll={{ x: 2000, y: 500 }}
              pagination={false}
            />
          )}
        </div>
      </Modal>
      {selectedRecord && isDownloading && (
        <DownloadLogs record={selectedRecord} onDownload={handleDownloadComplete} />
      )}
    </>
  );
}

export default FeeFilterList;
